const namespace = {
  summaryTitle: "About the neighborhood",
  summaryTitle_area: "About the area",
} as const;

export default namespace;
